import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { MatDialog } from "@angular/material/dialog";
import { MatOption } from '@angular/material/core';

//SERVICIOS
import { FacturacionService } from 'src/app/services/facturacion.service';


@Component({
  selector: 'app-pago-invitacion',
  templateUrl: './pago-invitacion.component.html',
  styleUrls: ['./pago-invitacion.component.scss']
})
export class PagoInvitacionComponent implements OnInit {

  idFactura:any
  factura: any
  precioLicencia: any
  total: any
  metodoPago:any
  tarjeta:any
  transferencia:any
  totalFront:any
  facturaId:any
  idContratista:any
  tipoPago:any
  button:any

  @ViewChild('buttonContainer') buttonContainer: any;
  constructor(
    private formBuilder: FormBuilder, private apollo: Apollo,
    public dialog: MatDialog, private facturaService: FacturacionService) {
      
     }

  ngOnInit(): void {
     this.buildForm()
     this.idFactura = this.facturaService.getIdFactura()
     this.getFacturaById()
    
  
  }

  private buildForm() {
    this.metodoPago = this.formBuilder.group({
      pago: ['tarjeta', [Validators.required]],
      policy: ['', [Validators.required]],
     
    });
  }

  setPolicy(e:any){
    if(e.target.checked){
      if(this.metodoPago.value.pago == 'tarjeta') {
        this.setTipoPago("tarjeta")
      }else{
        this.setTipoPago("transferencia")
      }
      
      this.button = true;
      
    } 
    else this.button = false
  }

  getFacturaById() {
    this.apollo.watchQuery<any>({
      query: this.facturaService.getFacturaById(),
      variables: {
        "id": this.idFactura
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       
        this.factura = data.factura
        this.precioLicencia = this.factura.precioUnitario.toFixed(2).toString().replace(/\./g,',')
        this.total = this.factura.precioTotal.toFixed(2)
        this.totalFront = this.factura.precioTotal.toFixed(2).toString().replace(/\./g,',')


    
        this.idContratista =  data.factura.contratista.id
        this.facturaId =  data.factura.id
        
        
        }
      )
  }

  setTipoPago(e:any){

    if (e == "tarjeta" || e == "transferencia") {
      this.tipoPago = e;
    }else{
      this.tipoPago = e.target.value
    }
    
    
    let formData = new FormData();

   
       
        formData.append('importe', this.total)
        formData.append('idContratista', this.idContratista)
        formData.append('idFactura', this.facturaId)
     
        if (this.tipoPago == "tarjeta") {

          
            fetch('https://tpv.inpsolutions.com/tpv/index.php', {
        method: 'POST',
        body: formData
        }).then(function (response) {
        return response.text();
        }).then((html) => {

       
        this.buttonContainer.nativeElement.innerHTML = html;
    
        }).catch(function (err) {
       
        console.warn('error.', err);
        }); 
        }
/* NO HAY PAGO TRANSFERENCIA FEBRERO 2022 */
        /* if (this.tipoPago == "transferencia") {
         
          fetch('https://tpv.inpsolutions.com/pisp/index.php', {
      method: 'POST',
      body: formData
      }).then(function (response) {
      return response.text();
      }).then((html) => {

     
      this.buttonContainer.nativeElement.innerHTML = html;
  
      }).catch(function (err) {
     
      console.warn('error.', err);
      }); 
      } */
  }

  

}
